import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ConfigServiceProvider } from '../../../modules/core/services/config-service/config-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'sellions-secured-img',
  template: ` <img #secured /> `,
})
export class SellionsSecuredImgComponent implements OnInit {
  @ViewChild('secured', { read: ElementRef }) securedImg: ElementRef;
  @Input() url: string;
  public src: string;
  private readonly placeholderPath = 'assets/images/photo_placeholder.png';

  constructor(private configService: ConfigServiceProvider, private http: HttpClient) {}

  ngOnInit() {
    if (!this.url) return;
    if (this.url === this.placeholderPath) this.src = this.placeholderPath;
    else this.src = this.configService.apiBaseUrl.slice(0, -1) + this.url;

    this.http
      .get(this.src, { responseType: 'blob' })
      .toPromise()
      .then((res) => {
        let blob = URL.createObjectURL(res);
        this.securedImg.nativeElement.src = blob;
      })
      .catch((res) => console.error('[SECURED-IMG]', res));
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-secured-img/sellions-secured-img.ts